var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPainlessDentistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 80,
    viewBox: "0 0 65 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303 -1500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,2A26,26,0,1,1,2,28,26,26,0,0,1,28,2Z",
    transform: "translate(314 1498)",
    fill: "#bee3f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.572,63a5.474,5.474,0,0,1-5.447-5.486c0-5.663-.011-10.083-.026-14.329l-.006-1.825,3.659,0V15.767a7.441,7.441,0,1,1,3.614,0V41.353l3.653,0V57.507A5.477,5.477,0,0,1,26.572,63ZM24.735,52.281c0,1.627,0,3.358,0,5.232a1.833,1.833,0,1,0,3.667-.005c0-1.438,0-3.311,0-5.226Zm3.67-7.286-3.685,0,0,.647.006,3h3.677c0-.764,0-1.49,0-2.149v-1.5ZM26.559,4.641A3.855,3.855,0,1,0,30.386,8.5,3.845,3.845,0,0,0,26.559,4.641ZM9.453,63a5.474,5.474,0,0,1-5.447-5.486L4,41.36l3.636,0V15.768A7.5,7.5,0,0,1,9.44,1V4.641a3.791,3.791,0,0,0-2.7,1.131,3.859,3.859,0,0,0,2.705,6.578h1.807v29l3.615,0c0,.005,0,.03,0,.069V41.5c0,.106,0,.266,0,.466s0,.437,0,.7v.294c.022,7.122.032,12.017.031,14.549A5.477,5.477,0,0,1,9.453,63ZM7.618,52.281l0,5.232a1.833,1.833,0,1,0,3.667-.005c0-1.388,0-3.244-.007-5.226Zm3.643-7.286L7.614,45l0,3.642h3.656C11.268,47.337,11.264,46.042,11.261,44.995Z",
    transform: "translate(301 1517)",
    fill: "#4299e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainlessDentistry);
export default __webpack_public_path__ + "static/media/painless-dentistry.f5c206abb37e68ebce11829f000b4351.svg";
export { ForwardRef as ReactComponent };